import { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import { getAllStudents } from '../../../../utils/api/student'
import { selectUser } from '../../../../reducers/UserReducer'
import { retrieveMetadata } from '../../../../utils/http'
import { Alert } from 'antd'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import Loading from '../../Loading'
import StudentsSelector from './StudentsSelector'
import { debounce } from 'lodash'

const AutoStudentsSelector = ({ disabled, style = {}, values, onChange }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [students, setStudents] = useState({ data: [], metadata: null })

  const fecthStudents = useCallback(parameters => {
    setLoading(true)

    getAllStudents(user, parameters).then(({ data, meta }) => {
      setStudents({ data, metadata: retrieveMetadata(meta) })
    }).finally(() => setLoading(false))
  }, [user])

  useEffect(() => {
    const fetch = debounce(() => fecthStudents({ page: 1, pageSize: 100, search }), 500)

    fetch()

    return () => fetch.cancel()
  }, [fecthStudents, search])

  const renderDropdown = menu => (
    <div>
      {students.metadata?.totalPages > 1 && (
        <Alert
          className='more-message'
          message={t('form.request.institutions_count_more')}
          type='info'
          showIcon
          banner
        />
      )}
      {loading ? (<Loading loading={loading} style={{ height: '100px' }} />) : menu}
    </div>
  )

  return (
    <StudentsSelector
      disabled={disabled}
      multiple='default'
      style={style}
      students={students.data}
      dropdownRender={renderDropdown}
      values={values}
      showSearch
      loading={loading}
      onChange={onChange}
      onSearch={setSearch}
    />
  )
}

export default AutoStudentsSelector
